import { render, staticRenderFns } from "./regions1.vue?vue&type=template&id=15c925d4&"
import script from "./regions1.vue?vue&type=script&lang=js&"
export * from "./regions1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports